import { render, staticRenderFns } from "./formats.vue?vue&type=template&id=0461856e&scoped=true"
import script from "./formats.vue?vue&type=script&lang=js"
export * from "./formats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0461856e",
  null
  
)

export default component.exports